import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import "./Company.css"
import { faBuilding, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import { changedThis } from '../../../reducers/models/company/companyList'
import ErrorAdd from "../../../util/ErrorAdd";
import CompanyChange from "../../../components/global/CompanyChange";

function HeaderCompany() {

    const dispatch = useDispatch();

    const stateCompany = useSelector((state) => state.companyList);//Информация о компаниях
    const stateSetting = useSelector((state) => state.setting);//Настройки приложения 
    const [loading, setLoading] = useState(false);
    const [nameCompany, setNameCompany] = useState(null);
    const [log, setLog] = useState(null);
    const [modalShow, setModalShow] = useState(false);

    useEffect(() => {
        if (stateSetting.user !== null & stateCompany.list.length > 0) {

            setNameCompany(stateCompany.list.filter(a => a.ID === stateSetting.user.ID_Company_Selected).length > 0 ? stateCompany.list.filter(a => a.ID === stateSetting.user.ID_Company_Selected)[0].Name : 'Без названия')
        }
    }, [stateCompany.list, stateSetting.user]);

    function companyChangeHandler(id) {
        setLoading(true);
        dispatch(changedThis());
        axios.post('/api_main/company/select', { ID_Company: id })
            .then((res) => {
                if (res.data.Status === 1) {
                    window.location.reload();
                }
                else {
                    setLoading(false);
                    setLog(res.data.Error);
                }
            })
            .catch((err) => {
                setLoading(false);
                setLog('Неизвестная ошибка')
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            {modalShow === true && (
                <CompanyChange onHide={() => setModalShow(false)} show={modalShow} selected={stateSetting.user !== null && stateSetting.user.ID_Company_Selected} changeHandler={companyChangeHandler} log={log} loading={loading} />
            )}

            {
                /*
                <Modal show={modalShow} onHide={() => setModalShow(false)} >
                <Modal.Body className="">
                    <div className="modal_title text-center mb-20"> Выберите компанию</div>
                    <div className="mb-15">
                        {stateCompany.list.filter(a => a.ID_Status === 1).map((item) => (
                            item.ID === stateSetting.user.ID_Company_Selected ? (
                                <div key={item.ID} className="list_item mt-15" style={{ cursor: "default", backgroundColor: "#e3e3e3" }}> <FontAwesomeIcon icon={faCheck} className="mr-15 text-success" />{item.Name}</div>

                            ) : (
                                <div key={item.ID} className="list_item mt-15" onClick={() => companyChangeHandler(item.ID)} > <FontAwesomeIcon icon={faBuilding} className="mr-15" />{item.Name}</div>
                            )
                        ))}
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    {loading === true && <div className="loader_01"></div>}
                </Modal.Body>
            </Modal>
                */
            }

            <div className="company_header" >
                <div className="title" onClick={() => setModalShow(true)}>
                    <FontAwesomeIcon icon={faBuilding} className="mr-10" />
                    {nameCompany}
                </div>
            </div>
        </>
    )
}

export default HeaderCompany;